<section class="legal-hero">
    <div class="container legal-hero__content">
        <h1>{{'privacy.title' | traduccion}}</h1>
        <p>{{'privacy.subtitle' | traduccion}}</p>
    </div>
</section>

<section class="legal-section">
    <div class="container">
        <mat-card class="legal-card">
            <div class="legal-content" [innerHtml]="'privacy.legalText' | traduccion"></div>
        </mat-card>
    </div>
</section>
